import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Sappiamo cosa finisce",
    body: "Detersivi, sieri, la lettiera del gatto, penne che spariscono. Ci sono cose che si consumano e vanno rinnovate. Ogni. Singolo. Mese.",
  },
  {
    n: "02",
    title: "Un solo rituale, non dieci carrelli",
    body: "Basta rincorrere sette negozi diversi. NEED riunisce casa, cura, vestiario, viaggio, pet e ufficio in un unico gesto mensile.",
  },
  {
    n: "03",
    title: "Ricorrente, ma mai rigido",
    body: "Scegli il tuo Box Mensile o crea una lista ricorrente. Modifica, sospendi o salta un mese quando la vita cambia ritmo.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 },
  }),
};

export const Manifesto = () => (
  <section id="manifesto" className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-36">
    <motion.p
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="mb-16 max-w-2xl font-serif text-3xl font-light leading-tight text-ink md:text-5xl"
      data-testid="manifesto-heading"
    >
      Non vendiamo prodotti.
      Curiamo <span className="italic text-sage">l'inevitabile bisogno ed il necessario possibile</span> — ciò che ricomprerai comunque, insieme a ciò che serve per l'occasione giusta.
    </motion.p>

    <div className="grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-ink/10 bg-ink/10 md:grid-cols-3">
      {chapters.map((c, i) => (
        <motion.div
          key={c.n}
          variants={reveal}
          custom={i}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="bg-cream p-8 md:p-10"
          data-testid={`manifesto-chapter-${c.n}`}
        >
          <span className="font-serif text-7xl font-light text-sage/70 md:text-8xl">{c.n}</span>
          <h3 className="mt-6 font-serif text-2xl text-ink md:text-3xl">{c.title}</h3>
          <p className="mt-4 text-sm leading-relaxed text-ink-soft md:text-base">{c.body}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
